import { Component, OnInit } from '@angular/core';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { Enrollment } from '../../models/enrollment.model';
import { EnrollmentService } from '../../services/enrollment.service';

@Component({
    selector: 'app-enrollments-list',
    templateUrl: './enrollments-list.component.html',
    styleUrls: ['./enrollments-list.component.scss']
})
export class EnrollmentsListComponent implements OnInit {

    public headerTitle     : string = 'Inscripciones';
    public headerButtonText: string = 'Nueva inscripción';
    public headerButtonIcon: string = 'plus-square';
    public headerButtonUrl : string = '/inscripcion/nueva';

    public isLoadingData      : boolean = true;
    public loadingMessage     : AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';
    public emptyMessage       : string = 'No tiene ninguna inscripción dada de alta.<br/>Pulse sobre el botón NUEVO para dar de alta una nueva inscripción.';

    public enrollments: Enrollment[];

    constructor(private enrollmentService: EnrollmentService) { }

    ngOnInit() {

        this.initData();

    }

    private initData() {

        this.enrollmentService.get().subscribe({

            next: (data: Enrollment[]) => {
                this.enrollments = data;
            },

            error: (error: any) => {
                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);
            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }


    private getEnrollments() {

        this.enrollmentService.get().subscribe({
            next: (data: Enrollment[]) => {
                this.enrollments = data;
            }
        }).add(() => {
            this.isLoadingData = false;
        });

    }

}
